import { render, staticRenderFns } from "./MessageListView.vue?vue&type=template&id=5bea1d76&scoped=true"
import script from "./MessageListView.vue?vue&type=script&lang=js"
export * from "./MessageListView.vue?vue&type=script&lang=js"
import style0 from "./MessageListView.vue?vue&type=style&index=0&id=5bea1d76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea1d76",
  null
  
)

export default component.exports